import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    user_data: {
        last_name: '',
        first_name: '',
        password: '',
        confirm_password: '',
        email: '',
        mobile_nummer: '',
    },
    taxpayer_number: '',

    credit_cart_number: '',
    city: '',
    has_experience: '',
    years_of_experience: '',
    prevPlaceWork: '',
    is_punctual: 1,
    is_stress_resistant: 1,
    speed_of_cleaning: 1,
    quality_of_cleaning: 1,
    teamwork: 'Так',
    has_own_equipment: 'Так',

    passportPhotos: [],
    profilePhoto: null,
}

const registrationCleanerSlice = createSlice({
    name: 'registrationCleanerSlice',
    initialState,
    reducers: {
        setUserData: (state, action) => {
            state.user_data = action.payload;
        },
        setTaxpayerNumber: (state, action) => {
            state.taxpayer_number = action.payload;
        },
        setCreditCartNumber: (state, action) => {
            state.credit_cart_number = action.payload;
        },

        setCity: (state, action) => {
            state.city = action.payload;
        },
        setHasExperience: (state, action) => {
            state.has_experience = action.payload;
        },
        setYearsOfExperience: (state, action) => {
            state.years_of_experience = action.payload;
        },
        setPrevPlaceWork: (state, action) => {
            state.prevPlaceWork = action.payload;
        },
        setPunctualityRating: (state, action) => {
            state.is_punctual = action.payload;
        },
        setStressResistanceRating: (state, action) => {
            state.is_stress_resistant = action.payload;
        },
        setCleaningSpeedRating: (state, action) => {
            state.speed_of_cleaning = action.payload;
        },
        setQualityCleaningRating: (state, action) => {
            state.quality_of_cleaning = action.payload;
        },
        setWillingnessWorkInTeam: (state, action) => {
            state.teamwork = action.payload;
        },
        setHavingCleaningSupplies: (state, action) => {
            state.has_own_equipment = action.payload;
        },

        setPassportPhotos: (state, action) => {
            state.passportPhotos = action.payload;
        },
        setProfilePhoto: (state, action) => {
            state.profilePhoto = action.payload;
        },
        clearAllData: (state, action) => {
            state.user_data = {};
            state.taxpayer_number = '';
            state.credit_cart_number = '';
            state.city = '';
            state.has_experience = '';
            state.years_of_experience = '';
            state.prevPlaceWork = '';
            state.is_punctual = 1;
            state.is_stress_resistant = 1;
            state.speed_of_cleaning = 1;
            state.quality_of_cleaning = 1;
            state.teamwork = 'Так';
            state.has_own_equipment = 'Так';
            state.passportPhotos = [];
            state.profilePhoto = null;
        },
    }
});

const {actions, reducer: registrationCleanerReducer} = registrationCleanerSlice;

const registrationCleanerActions = {
    ...actions,
}

export {
    registrationCleanerReducer,
    registrationCleanerActions,
}
